import { C1_FLOOR_FINISH_IMAGES } from "../data/C1_floorFinishes";
import type { C1_Floor } from "../model/C1_Floor";
import c1_state from "../model/C1_State";
import { useModel } from "../model/C1_useModel";
import { C1_FloorFinish } from "../types/C1_ModelTypes";

/** Converts the room polygon to SVG point syntax. */
function roomPolygonPoints(room: C1_Floor["rooms"][number], view: { x1: number; y1: number }, px: number): string {
  const result: string[] = [];
  for (const point of room.polygonPoints()) result.push(`${(point.x - view.x1) * px},${(point.y - view.y1) * px}`);
  return result.join(" ");
}

/** SVG-Entsprechung der HTML-Bodenebene für Bild- und PDF-Exporte. */
export function C1_FloorFinishSvgView({ floor }: { floor: C1_Floor }) {
  useModel(c1_state);
  const renderOptions = c1_state.floorImageRenderOptions.value;
  if (!renderOptions || (renderOptions.displayMode ?? c1_state.project.displayMode.value) !== "design") return null;

  const view = c1_state.view;
  const px = c1_state.svgPx;
  const opacity = c1_state.settings.floorFinishOpacity / 100;
  if (opacity <= 0) return null;

  return (
    <g data-c1-svg-layer="floor-finishes" pointerEvents="none">
      <defs>
        {floor.rooms.flatMap((room) => {
          const image = C1_FLOOR_FINISH_IMAGES[room.floorFinish];
          if (!image) return [];
          const patternId = `c1-floor-finish-${room.id}`;
          const tileSize = 2 * px;
          return [
            <pattern key={patternId} id={patternId} patternUnits="userSpaceOnUse" width={tileSize} height={tileSize}>
              <image href={image} x={0} y={0} width={tileSize} height={tileSize} preserveAspectRatio="none" />
            </pattern>,
          ];
        })}
      </defs>
      {floor.rooms.map((room) => {
        if (room.floorFinish === C1_FloorFinish.None) return null;
        const image = C1_FLOOR_FINISH_IMAGES[room.floorFinish];
        const color = room.floorFinish === C1_FloorFinish.General1
          ? c1_state.settings.floorColorGeneral1
          : room.floorFinish === C1_FloorFinish.General2
            ? c1_state.settings.floorColorGeneral2
            : undefined;
        const points = roomPolygonPoints(room, view, px);
        return (
          <polygon
            key={room.id}
            data-c1-room-id={room.id}
            points={points}
            fill={image ? `url(#c1-floor-finish-${room.id})` : color ?? "none"}
            opacity={opacity}
          />
        );
      })}
    </g>
  );
}
